
import React, { Component } from 'react';
import Modal from 'react-modal';
import Loader from './Loader';
import Pagination from './Pagination';
import { useLanguage } from '../../../utils/common/LanguageContext';


function StudentParticipationWrapper(props) {
    const { t } = useLanguage();
    return <StudentParticipation {...props} t={t} />;
}

class StudentParticipation extends Component {
    render() {
        const { t } = this.props;
        let pageDisplayCount = this.props.pageDisplayCount;
        const isGuestParticipation = this.props.participationType === 'guest';
        const searchTerm = (this.props.value || '').trim().toLowerCase();
        const attendanceDetails = this.props.studentAttendanceDetails || [];
        const typeFilteredAttendanceDetails = attendanceDetails.filter((student) => {
            if (this.props.participationType === 'guest') {
                return student?.thirdParty === true || (!!student?.email && !student?.name);
            }
            if (this.props.participationType === 'team') {
                return student?.thirdParty !== true;
            }
            return true;
        });
        const filteredAttendanceDetails = typeFilteredAttendanceDetails.filter((student) => {
            if (!searchTerm) {
                return true;
            }

            const primaryValue = isGuestParticipation
                ? student?.email || student?.name || ''
                : student?.name || student?.email || '';

            return primaryValue.toLowerCase().includes(searchTerm);
        });

        return (
            <Modal
                isOpen={this.props.openModal}
                onRequestClose={this.props.closeModal}
                className={'modal-width'}
                contentLabel="Example"
                overlayClassName={'modal-background z-index-1'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 rounded-lg bg-card">
                        <div className="flex items-start justify-between">
                            <h3 className="mt-0 text-lg font-medium text-white">
                                {this.props.isFromAdmin
                                    ? t('teamMemberName')
                                    : isGuestParticipation
                                                                            ? t('guestMemberParticipation')
                                      : t('teamMemberParticipation')}
                            </h3>
                            <button type="button" onClick={() => this.props.closeModal()}>
                                <svg
                                    className="styles_closeIcon__1QwbI"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        fill="white"
                                        d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        <input
                            type="text"
                            onChange={(e) => this.props.onChange(e)}
                            value={this.props.value || ''}
                            className="bg-dateselect text-white flex ml-auto rounded border-black-10 py-1.5 px-4 placeholder:text-secondary sm:text-base sm:leading-6 mt-2 mb-2"
                            placeholder={
                                isGuestParticipation
                                    ? t('searchGuestMemberName')
                                    : t('searchTeamMemberName')
                            }
                            autoComplete="off"
                            maxLength={50}
                        />
                        {this.props.isLoading ? (
                            <div className="mt-4">
                                <Loader />
                            </div>
                        ) : (
                            <>
                                <div className="mt-4 divide-y divide-slate-200">
                                    <div className="flex mb-2 font-semibold">
                                        {this.props.isBroadcastSession && (
                                            <div className="w-5/12 min-w-0 break-all">
                                                {t('primaryLevel3')}
                                            </div>
                                        )}
                                        <div className="w-5/12 min-w-0 text-white break-all">
                                            {isGuestParticipation
                                                ? t('guestMembers')
                                                : t('teamMemberName')}
                                        </div>
                                        {!this.props.hideStatus && !this.props.isFromAdmin && (
                                            <div className="w-2/12 text-white ps-2">{t('status')}</div>
                                        )}
                                    </div>
                                    {filteredAttendanceDetails.length ? (
                                        <>
                                            {filteredAttendanceDetails.map(
                                                (student, index) => (
                                                    <div
                                                        className="flex items-center py-4"
                                                        key={index}
                                                    >
                                                        {this.props.isBroadcastSession && (
                                                            <div className="w-5/12 min-w-0 text-white break-all">
                                                                {student.levelName}
                                                            </div>
                                                        )}
                                                        <div className="w-5/12 min-w-0 text-white break-all pr-2">
                                                            {isGuestParticipation
                                                                ? student.email || student.name
                                                                : student.name || student.email}
                                                        </div>
                                                        {!this.props.hideStatus &&
                                                            !this.props.isFromAdmin && (
                                                                <div
                                                                    className={`w-2/12 ps-2 ${
                                                                        student.userSessionStatus ===
                                                                        'NOT_JOINED'
                                                                            ? 'text-red'
                                                                            : 'text-green'
                                                                    }`}
                                                                >
                                                                    {' '}
                                                                    {student.userSessionStatus ===
                                                                    'NOT_JOINED'
                                                                        ? t('absent')
                                                                        : t('present')}
                                                                </div>
                                                            )}
                                                    </div>
                                                )
                                            )}{' '}
                                        </>
                                    ) : (
                                        <div className="py-3 text-center text-white">
                                            {t('noDataFound')}
                                        </div>
                                    )}
                                </div>
                                <div className="flex items-center justify-end gap-2 mt-4 -space-x-px">
                                    {pageDisplayCount > 1 && (
                                        <Pagination
                                            currentPage={this.props.currentPage}
                                            pageDisplayCount={pageDisplayCount}
                                            onPageChange={this.props.handlePageChange}
                                        />
                                    )}
                                </div>
                            </>
                        )}
                        {/* <div className="flex items-center justify-end pt-6 space-x-2">
              <button
                data-modal-hide="defaultModal"
                className="w-3/12 py-2 text-base font-semibold rounded-lg text-red border-red ring-1 ring-inset ring-red"
                onClick={() => this.props.closeModal()}
              >
                Cancel
              </button>
            </div> */}
                    </div>
                </div>
            </Modal>
        );
    }
}

export default StudentParticipationWrapper;
